import { useQueries } from '@tanstack/react-query';
import { clientOutputEventsImageMap } from '../../styles/assets/imageMap';

interface IUseClientOutput {
    data?: Record<string, string>;
    pending: boolean;
}
export function useClientOutputLifeEventImages(): IUseClientOutput {
    const clientOutputImageQuery = Object.keys(clientOutputEventsImageMap).map((imageKey: keyof typeof clientOutputEventsImageMap) => ({
        queryKey: ['client-output-life-event-image', imageKey],
        queryFn: async () => {
            const response = await fetch(clientOutputEventsImageMap[imageKey]);
            const buffer = await response.arrayBuffer();

            return { imageKey, image: btoa(String.fromCharCode(...new Uint8Array(buffer))) };
        },
        staleTime: Infinity,
    }));

    return useQueries({
        queries: clientOutputImageQuery,
        combine: (results) => {
            if (!results.some((result) => result.isSuccess)) {
                return { data: undefined, pending: true };
            }

            return {
                data: results.reduce(
                    (acc, result) => {
                        if (result.data?.imageKey) {
                            acc[result.data.imageKey] = result.data.image;
                        }

                        return acc;
                    },
                    {} as Record<string, string>,
                ),
                pending: false,
            };
        },
    });
}
